export default "__VITE_ASSET__9df5416b__"